import React from "react";
import { apiListPos } from "@/lib/api";
import { petaPos } from "@/lib/posNama";

// v2.17.2: the station names, loaded once per page load and shared by every screen that shows a station
let cache = null;
let janji = null;

export default function usePetaPos() {
  const [peta, setPeta] = React.useState(cache || {});
  React.useEffect(() => {
    if (cache) return undefined;
    let hidup = true;
    janji = janji || apiListPos().then((l) => (cache = petaPos(l))).catch(() => { janji = null; return {}; });
    janji.then((p) => { if (hidup) setPeta(p); });
    return () => { hidup = false; };
  }, []);
  return peta;
}
